export type SiteReport = {
  slug: string;
  title: string;
  date: string;
  sector: string;
  site: string;
  duration: string;
  image: string;
  summary: string;
  facts: { label: string; value: string }[];
  highlights: string[];
};

export const siteReports: SiteReport[] = [
  {
    slug: 'cuves-inox-zone-industrielle',
    title: 'Quatre cuves inox livrées sans arrêter la ligne',
    date: 'Octobre 2026',
    sector: 'Agro-industrie',
    site: 'Zone industrielle de Douala',
    duration: '6 semaines',
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.05.26-1.jpeg',
    summary:
      "Les quatre cuves de 12 m³ ont été préfabriquées à Logbaba, contrôlées en atelier, puis montées en deux nuits d'intervention pendant que la production continuait.",
    facts: [
      { label: 'Ouvrages', value: '4 cuves de 12 m³' },
      { label: 'Équipe', value: '6 compagnons' },
      { label: 'Interruption', value: 'Aucune' },
    ],
    highlights: [
      'Soudures intérieures TIG avec purge argon et passivation',
      'Contrôle dimensionnel complet avant départ d’atelier',
      'Test hydraulique validé à 100 % à la réception',
    ],
  },
  {
    slug: 'reseau-vapeur-bonaberi',
    title: 'Réseau vapeur remis en service à Bonabéri',
    date: 'Septembre 2026',
    sector: 'Énergie',
    site: 'Bonabéri, Douala',
    duration: '9 semaines',
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.05.27.jpeg',
    summary:
      "Remplacement de 480 mètres linéaires de tuyauterie vapeur, avec recalcul des dilatations et reprise complète du supportage sur le parcours existant.",
    facts: [
      { label: 'Linéaire', value: '480 ml' },
      { label: 'Pression', value: 'Réseau HP' },
      { label: 'Arrêts de chauffe', value: '0 depuis' },
    ],
    highlights: [
      'Lyres de dilatation ajoutées et supports fixes repositionnés',
      'Tronçons préfabriqués et repérés avant montage en hauteur',
      'Pentes et points de purge vérifiés un par un',
    ],
  },
  {
    slug: 'charpente-convoyeur-cimenterie',
    title: 'Charpente de convoyeur montée pendant l’arrêt',
    date: 'Juillet 2026',
    sector: 'Cimenterie',
    site: 'Littoral, Cameroun',
    duration: '5 semaines',
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.04.28.jpeg',
    summary:
      "Trente-quatre tonnes d’acier découpées en trois modules levables, assemblées et boulonnées dans la fenêtre d’arrêt technique programmée par le site.",
    facts: [
      { label: 'Tonnage', value: '34 t' },
      { label: 'Portée', value: '18 m sans appui' },
      { label: 'Montage', value: 'Avant fin d’arrêt' },
    ],
    highlights: [
      'Contreventement provisoire et plan de levage adaptés au site',
      'Boulonnage HR contrôlé au couple',
      'Flèche mesurée sous le seuil d’étude après mise en charge',
    ],
  },
  {
    slug: 'portique-portuaire-anticorrosion',
    title: 'Portique portuaire protégé pour l’ambiance saline',
    date: 'Juin 2026',
    sector: 'Logistique portuaire',
    site: 'Port de Douala',
    duration: '7 semaines',
    image: 'https://sgsctic.com/wp-content/uploads/2026/01/metal-painting2-687x318-1.jpg',
    summary:
      "Fabrication d’un portique de manutention avec chemin de roulement, puis sablage et système peinture trois couches adapté à l’air marin.",
    facts: [
      { label: 'Acier', value: '12 t' },
      { label: 'Peinture', value: '3 couches' },
      { label: 'Reprise', value: 'Aucune' },
    ],
    highlights: [
      'Goussets renforcés pour la charge roulante',
      'Soudure continue sur les zones exposées',
      'Épaisseur sèche contrôlée sur chaque zone traitée',
    ],
  },
  {
    slug: 'lignes-process-remises-conformite',
    title: 'Trois lignes process remises en conformité',
    date: 'Mai 2026',
    sector: 'Industries manufacturières',
    site: 'Douala, Bassa',
    duration: '5 semaines',
    image:
      'https://sgsctic.com/wp-content/uploads/2026/01/WhatsApp-Image-2025-12-19-at-10.39.37-1.jpeg',
    summary:
      "Relevé complet d’un existant modifié au fil des ans, puis reprise des tronçons, ajout de vannes et remise à jour des isométriques.",
    facts: [
      { label: 'Lignes', value: '3 circuits' },
      { label: 'Production', value: 'Maintenue' },
      { label: 'Livrable', value: 'Plans à jour' },
    ],
    highlights: [
      'Relevé et isométriques reconstitués avant travaux',
      'Intervention ligne par ligne, sans arrêt global',
      'Dossier de plans remis au service maintenance',
    ],
  },
];

export type TrainingSession = {
  program: string;
  slug: string;
  dates: string;
  duration: string;
  seats: string;
  status: 'ouvert' | 'dernieres-places' | 'complet';
};

export const trainingSessions: TrainingSession[] = [
  {
    program: 'Soudure multi-procédés',
    slug: 'soudure-multi-procedes',
    dates: '16 novembre – 11 décembre 2026',
    duration: '4 semaines · 160 h',
    seats: '3 places',
    status: 'dernieres-places',
  },
  {
    program: 'Chaudronnerie & traçage',
    slug: 'chaudronnerie-tracage',
    dates: '4 janvier – 13 février 2027',
    duration: '6 semaines · 240 h',
    seats: '5 places',
    status: 'ouvert',
  },
  {
    program: 'Tuyauterie industrielle',
    slug: 'tuyauterie-industrielle',
    dates: '18 janvier – 19 février 2027',
    duration: '5 semaines · 200 h',
    seats: '4 places',
    status: 'ouvert',
  },
  {
    program: 'Montage & échafaudage',
    slug: 'montage-echafaudage',
    dates: '11 – 15 janvier 2027',
    duration: '1 semaine · 40 h',
    seats: 'Complet',
    status: 'complet',
  },
  {
    program: 'Lecture de plans & HSE',
    slug: 'lecture-plans-hse',
    dates: '1er – 12 février 2027',
    duration: '2 semaines · 80 h',
    seats: '8 places',
    status: 'ouvert',
  },
];

export const newsFigures = [
  { value: 5, suffix: '', label: 'Chantiers documentés', hint: 'Comptes rendus publiés' },
  { value: 5, suffix: '', label: 'Sessions programmées', hint: 'Novembre → février' },
  { value: 8, suffix: '', label: 'Stagiaires par groupe', hint: 'Encadrement rapproché' },
];